document.addEventListener('DOMContentLoaded', () => {
  const mediaImages = document.querySelectorAll(
    '.product__media img, .product-media img, [data-product-media] img'
  );

  mediaImages.forEach((img) => {
    if (img.dataset.zoomBound === 'true') return;
    img.dataset.zoomBound = 'true';
    img.style.cursor = 'zoom-in';

    img.addEventListener('click', () => {
      const overlay = document.createElement('div');
      overlay.className = 'custom-zoom-overlay';
      overlay.innerHTML = `
        <button class="custom-zoom-close" aria-label="Close zoom">×</button>
        <img src="${img.currentSrc || img.src}" alt="${img.alt || ''}" class="custom-zoom-image">
      `;
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';

      const removeOverlay = () => {
        overlay.remove();
        document.body.style.overflow = '';
      };

      overlay.addEventListener('click', (e) => {
        if (
          e.target.classList.contains('custom-zoom-overlay') ||
          e.target.classList.contains('custom-zoom-close')
        ) {
          removeOverlay();
        }
      });

      document.addEventListener(
        'keydown',
        function escHandler(e) {
          if (e.key === 'Escape') {
            removeOverlay();
            document.removeEventListener('keydown', escHandler);
          }
        }
      );
    });
  });
});